import * as React from 'react'
import ImagePDF from "assets/images/pdf.png";
import ImageXML from "assets/images/xml.png";
import { 
   FilesTitle,
   ImagesContainer,
   ImageText
} from './StepThreeStyle.js'

import { useInvoice } from "store/context";

function StepThree() {
   const { state: {invoice} } = useInvoice();
   return (
      <div>
         <FilesTitle>¡Se han creado los archivos exitosamente!</FilesTitle>

         <ImagesContainer>
         <div>
            <img src={ImageXML} alt="xml icono" />
            <ImageText href={invoice.cfdiUrl} target="_blank">Descargar</ImageText>
            
         </div>
         <div>
            <img src={ImagePDF} alt="pdf icono" />
            <ImageText href={invoice.pdfUrl} target="_blank">Descargar</ImageText>
            
         </div>
      </ImagesContainer>
      </div>
      )
}

export default StepThree;